<template>
  <div class="content">
    <div class="col-md-8 flex-container-top">
      <base-button
        type="primary"
        round
        icon
        class="top-button-back"
        @click="$router.push('list')"
      >
        <i class="fa fa-arrow-left"></i>
      </base-button>

      <h2 v-if="!isEdit" class="text-center">Add Sport</h2>
      <h2 v-if="isEdit" class="text-center">Edit Sport</h2>
    </div>

    <div class="row">
      <div class="col-md-8">
        <card>
          <form onSubmit="return false;">
            <div class="row">
              <div class="mt-4 col-md-12">
                <base-input
                  type="text"
                  label="Sport Name*"
                  maxlength="50"
                  placeholder="Name"
                  v-model="name"
                >
                </base-input>
              </div>
            </div>

            <div class="row" style="padding: 30px"></div>

            <base-button
              v-if="!isEdit"
              native-type="submit"
              type="primary"
              class="btn-fill col-md-12"
              :disabled="loading"
              @click="saveSport()"
            >
              Save
            </base-button>

            <base-button
              v-if="isEdit"
              native-type="submit"
              type="primary"
              class="btn-fill col-md-12"
              :disabled="loading"
              @click="saveSport()"
            >
              Update
            </base-button>

            <div class="row" style="padding: 10px"></div>
          </form>
        </card>
      </div>

      <div class="col-md-4">
        <card class="card-user">
          <p class="card-text"></p>
          <div class="author">
            <div class="block block-one"></div>
            <div class="block block-two"></div>
            <div class="block block-three"></div>
            <div class="block block-four"></div>
            <div class="col-md-12 col-sm-12">
              <h4 class="card-title">Sport Image</h4>
              <image-upload
                :src="image"
                @change="onImageChange"
                :select-text="isEdit ? 'Update Image' : 'Select Image'"
              />
            </div>
          </div>
        </card>
      </div>
    </div>

    <div class="full-screen-loader" v-if="loading">
      <div class="sk-chase">
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
        <div class="sk-chase-dot"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ImageUpload } from "src/components/index";

export default {
  components: {
    ImageUpload,
  },
  data() {
    return {
      name: "",
      image: null,
      isEdit: false,
      loading: false,
      imageUploaded: false,
    };
  },
  async mounted() {
    let id = this.$route.query.id;
    if (id == -1) {
      this.isEdit = false;
      return;
    }

    this.isEdit = true;
    await this.loadSport(id);
  },
  methods: {
    getSportApiMessage(response, fallbackMessage) {
      return (
        (response &&
          response.error &&
          response.error.response &&
          response.error.response.data &&
          response.error.response.data.Message) ||
        (response && response.apidata && response.apidata.Message) ||
        fallbackMessage
      );
    },
    isSportApiSuccess(response) {
      const apiData = response && response.apidata;

      if (!apiData) {
        return false;
      }

      return apiData.Code === "P00001" || apiData.Message === "Success";
    },
    async loadSport(id) {
      this.loading = true;
      try {
        const response = await this.$apiService.getCall(
          "event/admin/game/" + id
        );
        const sport = response.apidata && response.apidata.Data;

        if (!sport) {
          this.$apiService.notify("Sport was not found.");
          this.$router.push("/sports/list");
          return;
        }

        this.name = sport.game_name || sport.name || "";
        this.image = sport.image_url || sport.imageUrl || sport.image || null;
      } finally {
        this.loading = false;
      }
    },
    async saveSport() {
      if (!this.name) {
        this.$apiService.notify("Name is mandatory.");
        return;
      }
      if (!this.image) {
        this.$apiService.notify("Image is mandatory.");
        return;
      }

      this.loading = true;

      try {
        let imageUrl = this.image;
        if (this.imageUploaded) {
          imageUrl = await this.$apiService.uploadImage(this.image);
        }

        if (!imageUrl) {
          this.$apiService.notify("Image upload failed.");
          return;
        }

        const sportData = {
          name: this.name.trim(),
          image_url: imageUrl,
        };

        const id = this.$route.query.id;
        const response = this.isEdit
          ? await this.$apiService.putCall("event/edit-game/" + id, sportData)
          : await this.$apiService.postCall("event/create-game", sportData);

        if (response.isError || !this.isSportApiSuccess(response)) {
          this.$apiService.notify(
            this.getSportApiMessage(response, "Unable to save sport.")
          );
          return;
        }

        this.$apiService.notify(
          this.isEdit ? "Sport has been updated." : "Sport has been added."
        );
        this.$router.push("/sports/list");
      } finally {
        this.loading = false;
      }
    },
    onImageChange(file) {
      this.image = file;
      this.imageUploaded = true;
    },
  },
};
</script>
